import { AccountantService } from "./../../../main/accountant/accountant.service";
import { Input, OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { ResourcesPanelWidgetComponent } from "../../../main/panels/resources-panel.component";
import { AppsPanelWidgetComponent } from "../../../main/panels/apps-panel.component";

@Component({
    selector: "app-apps-and-resources",
    templateUrl: "./apps-and-resources.component.html",
    styleUrls: [
        "./apps-and-resources.component.scss",
        "../../../main/accountant/tracked-items-dashboard.component.css",
        "../../../files-manager/files-manager.component.scss",
        "../../templates.component.scss",
        "../../../main/common/apps.component.css",
    ],
    imports: [AppsPanelWidgetComponent, ResourcesPanelWidgetComponent]
})
export class AppsAndResourcesComponent implements OnInit {
  @Input() data;
  @Input() company;

  company_apps = [];
  preview;
  company_resources = [];

  constructor(private accountantService: AccountantService) {}

  ngOnInit(): void {
    this.getDefaultApps();
    this.getDefaultResources();
  }

  getDefaultApps(): void {
    this.accountantService
      .get_company_default_apps()
      .then(({ company_default_apps }: any) => {
        console.log(company_default_apps);
        this.company.apps = company_default_apps;
      });
  }

  getDefaultResources(): void {
    this.accountantService
      .get_company_default_resources()
      .then(({ company_default_resources }: any) => {
        console.log(company_default_resources);
        this.company.resources = company_default_resources;
      });
  }
}
